const OPEN_WEATHER_BASE_URL = 'https://api.openweathermap.org/data/2.5'
export const WEATHER = OPEN_WEATHER_BASE_URL + '/weather'
export const FORECAST = OPEN_WEATHER_BASE_URL + '/forecast'
export const APP_ID = '19b7dec4c4e6da26f3d8e5c9c60d15ac'
